import React, { Component } from 'react';

import { CSSTransitionGroup } from 'react-transition-group';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';

import { SyncLoader } from 'halogenium';

import { surveyVerification, displayLoader, submitSurvey } from 'actions/surveyActions';

import SurveyForm from './components/SurveyForm';
import { getTranslatedString } from 'helpers/i18n';

export default connect(
  store => {
    return {
      surveyQuestions: store.survey.surveyQuestions,
      surveyTitle: store.survey.surveyTitle,
      surveyDescription: store.survey.surveyDescription,
      tenantFirstName: store.survey.tenantFirstName,
      surveyInProgress: store.survey.surveyInProgress,
      surveyVerification: store.survey.surveyVerification,
      surveyVerificationMessage: store.survey.surveyVerificationMessage,
      showSuccessfulVerificationMessage: store.survey.showSuccessfulVerificationMessage,
      showLoader: store.survey.showLoader,
    };
  },
  { surveyVerification, displayLoader, submitSurvey }
)(
  class TenantSurvey extends Component {
    componentDidMount() {
      const query_params = browserHistory.getCurrentLocation().query;
      this.props.displayLoader(true);
      this.props.surveyVerification(query_params.uuid, query_params.access_token);
    }

    handleSubmit = values => {
      const query_params = browserHistory.getCurrentLocation().query;
      return this.props.submitSurvey(query_params.uuid, query_params.access_token, values);
    };

    render() {
      return (
        <div className="container application-container">
          {this.props.showLoader && (
            <div style={{ marginTop: '25px' }}>
              <SyncLoader color="#ff5656" size="12px" />
            </div>
          )}

          {this.props.surveyVerificationMessage && (
            <CSSTransitionGroup transitionName="fade_in" transitionAppear={true}>
              <div>
                <h3
                  style={{
                    textAlign: 'center',
                    fontSize: '30px',
                    margin: '30px',
                  }}
                >
                  {getTranslatedString(this.props.surveyVerificationMessage)}
                </h3>
              </div>
            </CSSTransitionGroup>
          )}

          {this.props.showSuccessfulVerificationMessage && (
            <CSSTransitionGroup transitionName="fade_in" transitionAppear={true}>
              <div>
                <h3
                  style={{
                    textAlign: 'center',
                    fontSize: '30px',
                    margin: '30px',
                  }}
                >
                  {' '}
                  {this.props.surveyTitle}
                </h3>
                <p>{this.props.surveyDescription}</p>
                <div className="row" style={{ textAlign: 'center' }}>
                  <div>
                    <h1>
                      {getTranslatedString('tenantPortal.surveys.thankYouForFeedback')}{' '}
                      {this.props.tenantFirstName}!
                    </h1>
                  </div>
                </div>
              </div>
            </CSSTransitionGroup>
          )}

          {this.props.surveyInProgress && (
            <CSSTransitionGroup transitionName="fade_in" transitionAppear={true}>
              <div>
                <h3
                  style={{
                    textAlign: 'center',
                    fontSize: '30px',
                    marginBottom: '10px',
                  }}
                >
                  {this.props.surveyTitle}
                </h3>
                <p>{this.props.surveyDescription}</p>
                <div className="row" style={{ textAlign: 'center', marginTop: '30px' }}>
                  <div>
                    <h3>
                      {getTranslatedString('hi')} {this.props.tenantFirstName}!
                    </h3>
                    <h4 style={{ fontSize: '14px', textAlign: 'justify' }}>
                      {getTranslatedString('tenantPortal.surveys.yourFeedbackIsImportant')}
                    </h4>
                  </div>
                  <SurveyForm
                    onSubmit={this.handleSubmit}
                    surveyQuestions={this.props.surveyQuestions}
                  />
                  <div style={{ marginTop: '50px' }} />
                </div>
              </div>
            </CSSTransitionGroup>
          )}
        </div>
      );
    }
  }
);
